/**
 * Visit situations computed from scores, fame and `routeMeta`.
 * Not stored as tags.
 */
export enum AttractionScenarioEnum {
    WITH_KIDS = 'with_kids',
    FREE = 'free',
    RAINY = 'rainy',
    EVENING = 'evening',
    SHORT_VISIT = 'short_visit',
    LONG_VISIT = 'long_visit',
    PHOTOGENIC = 'photogenic',
    FIRST_VISIT = 'first_visit',
    HIDDEN_GEM = 'hidden_gem',
    LOCAL = 'local',
    SUNSET = 'sunset',
}
